import { SectionLabel, Reveal } from "../landing/shared";
import ApplyForm from "./ApplyForm";

const TRUST = [
  "No fee to you for the review",
  "Not an approval, a quote, or a commitment to lend",
  "Reviewed personally by Josh",
  "A limited number of Better Deal Reviews™ are available after each live class",
];

export default function ApplySection() {
  return (
    <section id="apply" className="relative py-24 lg:py-36 px-6 lg:px-10 bg-[#00224F]/50 bg-grid-80 overflow-hidden" data-testid="apply-section">
      <div
        className="absolute left-0 top-1/2 -translate-y-1/2 w-[700px] h-[700px] pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(1,98,202,0.18) 0%, transparent 65%)" }}
      />
      <div className="relative max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <SectionLabel n="008" text="YOUR NEXT STEP" />
          <h2
            className="font-black uppercase tracking-tight leading-[0.98]"
            style={{ fontSize: "clamp(32px, 4vw, 56px)" }}
          >
            CLARIFY THE BENEFIT. STRUCTURE THE DEAL.{" "}
            <span className="text-[#0162CA]">KNOW YOUR NEXT STEP.</span>
          </h2>
          <ul className="mt-10 space-y-4">
            {TRUST.map((t, i) => (
              <li key={i} className="flex gap-3 text-white/70 text-[15px] leading-relaxed" data-testid={`apply-trust-bullet-${i + 1}`}>
                <span className="text-[#0162CA] font-bold shrink-0">✓</span>
                {t}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="border border-white/12 bg-[#001736]/70 backdrop-blur-xl p-6 sm:p-8">
            <p className="font-mono-strict text-[11px] tracking-[0.3em] text-[#0162CA] mb-6">REQUEST YOUR REVIEW</p>
            <ApplyForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
